import React, { useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { ConfirmModal, CourseExplorer } from "@components";
import { deleteAllSavedCoursesAction } from "@redux/modules/course/slices";
import { APP_TITLE_SUFFIX } from "@constants";
import { formatNumberText } from "@helpers";

const SavedCoursesPage = () => {
  const { exploreCourse } = useSelector((state) => state.course);
  const dispatch = useDispatch();

  const handleUnSaveAll = () => {
    dispatch(deleteAllSavedCoursesAction());
  };

  useLayoutEffect(() => {
    document.title = `Saved courses | ${APP_TITLE_SUFFIX}`;
    return () => {
      document.title = APP_TITLE_SUFFIX;
    };
  }, []);

  const totalSavedCourses =
    exploreCourse.data?.filter((course) => course.isSave === true).length || 0;

  return (
    <CourseExplorer
      title={
        <div className="d-flex justify-content-between align-items-center">
          <span>{formatNumberText(totalSavedCourses, "Saved Course")}</span>
          <ConfirmModal
            onSubmit={handleUnSaveAll}
            title="Confirm Unsaved"
            body="Do you really want to unsaved all courses?"
            submitButton="Unsave all"
            disabled={!exploreCourse.data?.length}
          >
            <Button disabled={!totalSavedCourses}>
              <i className="bi bi-trash mr-2"></i>
              Unsave all
            </Button>
          </ConfirmModal>
        </div>
      }
      extraSearchParams={{ StatusOfUser: 1 }}
    />
  );
};

/* required: display name */
SavedCoursesPage.displayName = "SavedCoursesPage";

/* required: props types */
SavedCoursesPage.propTypes = {};

/* required: default props */
SavedCoursesPage.defaultProps = {};

export { SavedCoursesPage };
